/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_DeletingInputs */

const en_lesson_deleting = /** @type {(inputs: Lesson_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting…`)
};

const he_lesson_deleting = /** @type {(inputs: Lesson_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוחק…`)
};

/**
* | output |
* | --- |
* | "Deleting…" |
*
* @param {Lesson_DeletingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_deleting = /** @type {((inputs?: Lesson_DeletingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_DeletingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_deleting(inputs)
	return he_lesson_deleting(inputs)
});